import { CART_RECEIVE, CART_SHOW_MINI_CART } from '../constants';

export const cart = (
    state = { },
    action
) => {
    switch (action.type) {
        case CART_RECEIVE:
        case CART_SHOW_MINI_CART:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
};
